<template>
    <div class="reminder-detail-page">
        <div class="head">
            <i class="back"
               @click="back()"></i>
            <p class="title">通知时间</p>
            <p class="send"
               :class="is_schedule==null?'gary':''"
               @click="selectTime()">确定</p>
        </div>
        <div class="sendTime">
            <div class="item tongzhi"
                 :class="is_schedule==0?'active':''"
                 @click="handleSelect">立即通知</div>
            <div class="item dingshi"
                 :class="is_schedule==1?'active':''">定时发送 <span class="time">{{defaultTimeStr}}</span>
                <span class="date-time-area">
                    <DatePicker keys="1"
                                :dateType="1"
                                width="100"
                                bgColor="#eeeeee"
                                placeholder=""
                                title="请选择定时发送时间"
                                :startYear="0"
                                :endYear="1"
                                :defaultTime.sync="defaultTime"
                                :defaultTimeStr.sync="defaultTimeStr"
                                @getDateValue="getDateValue"></DatePicker>
                </span>
            </div>
        </div>

    </div>
</template>

<script>
import DatePicker from 'SRC/components/date-time-picker/index.vue'
export default {
    components: {
        DatePicker,
    },
    data () {
        return {
            is_schedule: JSON.parse(localStorage.getItem('is_schedule')) == null ? null : JSON.parse(localStorage.getItem('is_schedule')) == 0 ? 0 : 1,
            defaultTime: JSON.parse(localStorage.getItem('defaultTime')) ? JSON.parse(localStorage.getItem('defaultTime')) : '',
            defaultTimeStr: JSON.parse(localStorage.getItem('defaultTimeStr')) ? JSON.parse(localStorage.getItem('defaultTimeStr')) : '',
        }
    },
    created () {
        this.defaultTime = ''
    },
    methods: {
        getDateValue (val, keys) {
            //点击确定获取值
            this.is_schedule = 1
        },
        handleSelect () {
            this.is_schedule = 0
            this.defaultTime = ''
            this.defaultTimeStr = ''
        },

        selectTime () {
            if (this.is_schedule === null) {
                layer.tips('请先选择通知时间')
                return
            }
            if (this.is_schedule === 0) {
                //如果选择的是立即通知
                localStorage.setItem('is_schedule', 0)
                localStorage.removeItem('defaultTime')
                localStorage.removeItem('defaultTimeStr')
            } else if (this.is_schedule === 1) {
                //判断所选时间是否小于当前时间，小于则不通过
                let selectTimps = this.getTimeFormat(this.defaultTime)
                let nowTimps = Date.now()
                if (selectTimps <= nowTimps) {
                    layer.tips('定时时间不能小于当前时间')
                    this.defaultTime = ''
                    return
                }
                localStorage.setItem('defaultTime', JSON.stringify(this.defaultTime))
                localStorage.setItem('defaultTimeStr', JSON.stringify(this.defaultTimeStr))
                localStorage.setItem('is_schedule', 1)
            }
            // this.$router.replace('/reminder/send')
            //这里需要再加个go(-1)，防止返回到上个页面，再点后退没反应
            this.$router.go(-1)
        },
        //年月日转时间戳
        getTimeFormat (timeS) {
            let time = (new Date(timeS).getTime()); //除1000 是变成秒级的时间戳 不除就是毫秒级
            return time;
        }
    },

}
</script>

<style lang="scss" scoped>
.reminder-detail-page {
    padding-top: 96px / $ppr;
}
.head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;

    .back {
        position: absolute;
        top: 0;
        left: 0;
        width: 76px / $ppr;
        height: 96px / $ppr;
        background: url(../img/choose_back.png) no-repeat center;
        background-size: 18px / $ppr 34px / $ppr;
    }

    .title {
        width: 100%;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 34px / $ppr;
        color: #fff;
        text-align: center;
    }
    .send {
        position: absolute;
        top: 0;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        right: 24px / $ppr;
        z-index: 10;
        font-size: 30px / $ppr;
        color: #fff;
    }
    .gary {
        color: #e8e8e8;
    }
}
.sendTime {
    .item {
        padding: 24px / $ppr;
        background: #fff;
    }
    .dingshi {
        border-top: 1px / $ppr solid #e8e8e8;
        display: flex;
        align-items: center;
        position: relative;
        .time {
            margin-left: 20px / $ppr;
            color: #999;
        }
        .date-time-area {
            opacity: 0;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
    .active {
        color: #5e89ef;
        background: #fff url("../release/img/icon-xuanzhong.png") no-repeat 97%
            center;
        background-size: 32px / $ppr 32px / $ppr;
    }
}
.bottom-content {
    background: $c-fbg;
    display: flex;
    display: -webkit-flex;
    span {
        flex: 1;
        -webkit-flex: 1;
        display: inline-block;
        text-align: center;
        font-size: $lg;
        line-height: $h-header;
    }
    .btn {
        color: $c-tag;
    }
}
</style>